import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "afa_token";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return detail.msg || String(detail);
}

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n) || 0);

export const fmtDate = (s) => (s && s.length >= 10 ? `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}` : "—");

export const slotLabel = (h) =>
  h == null ? "—" : `${String(h).padStart(2, "0")}:00 – ${String(h + 1).padStart(2, "0")}:00`;

export const todayRome = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" });

export async function openPdf(path) {
  const w = window.open("", "_blank");
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  if (w) w.location.href = url; else window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export async function downloadPdf(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

export const publicDdtUrl = (token) => `${BACKEND_URL}/api/public/ddt/${token}/pdf`;
